import {
  arrayOf, bool, shape, string, func
} from 'prop-types';

export const propTypes = {
  collection: shape({
    collectionId: string,
    curations: arrayOf(string),
    metadata: shape({
      name: string
    })
  }).isRequired,
  preview: bool,
  spaceCollectionId: string.isRequired,
  skipFn: func.isRequired,
  storeId: string.isRequired
};

export const defaultProps = {
  preview: false
};
